import { AuthType, OrgCredential, OrgCredentialType } from '@/types/credentials'

export const editableAuthTypes = ['secret', 'token', 'basic_with_url']

export const authLabelMap: Record<AuthType, string> = {
  secret: 'Client ID and Secret',
  token: 'API Token',
  basic_with_url: 'Credential Details',
  oauth2: '',
}

export function orgCredentialTypeHasEditableAuthType(
  orgCredentialType: OrgCredentialType,
) {
  const authTypes = orgCredentialType?.auth_type || []
  return authTypes.some((authType) => editableAuthTypes.includes(authType))
}

export function isAuthenticated(orgCredential: OrgCredential) {
  const authTypes = orgCredential.type?.auth_type || []
  if (authTypes.includes('oauth2') && orgCredential.needs_auth) return false

  if (
    authTypes.some((authType) => editableAuthTypes.includes(authType)) &&
    orgCredential.needs_secrets
  )
    return false
  return true
}
